const InvoiceTemplate = ({ invoiceItem, invoiceRef }: { invoiceItem: any; invoiceRef: any }) => {
    const totalAmount = Number(invoiceItem.invoice_amount || 0);

    const baseAmount = totalAmount / 1.18;
    const gstAmount = totalAmount - baseAmount;
    return (
        <div
            className="container mt-4"
            style={{ position: "absolute", left: "-9999px", top: 0 }}
        >
            <div className="template-invoice-wrap p-4" ref={invoiceRef} id="invoice">
                {/* Header */}
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <img src="/logo-h.png" alt="logo" style={{ height: 50 }} />
                    </div>
                    <div className="col-md-6 text-end">
                        <h2>Invoice</h2>
                    </div>
                </div>
                {/* Company + Invoice Info */}
                <div className="row mt-4">
                    <div className="col-md-6">
                        <h6>Codexo Software Pvt. Ltd.</h6>
                        <p>G9 Okay Plus Spaces, Malviya Nagar </p>
                        <p>Jaipur, Rajasthan 302017</p>
                        <p>Email: info@codexosoftware.com</p>
                    </div>
                    <div className="col-md-6 text-end">
                        <p><strong>Invoice No:</strong> {invoiceItem.inovoice_order_id || '-'}</p>
                        <p><strong>Date:</strong> {invoiceItem.createdAt ? new Date(invoiceItem.createdAt).toLocaleDateString() : '-'}</p>
                        <p><strong>Customer No:</strong> {invoiceItem.invoice_bill_contact_no || '-'}</p>
                    </div>
                </div>
                <hr />
                {/* Billing */}
                <div className="row">
                    <div className="col-md-6">
                        <h6>Billed To</h6>
                        <p>{invoiceItem.invoice_bill_name || '-'}</p>
                        <p>{invoiceItem.invoice_bill_email || '-'}</p>
                        <p>+91 {invoiceItem.invoice_bill_contact_no || '-'}</p>
                        <p>{invoiceItem.invoice_bill_gst_no || '-'}</p>
                        <p>
                            {invoiceItem.invoice_bill_street_name},
                            {invoiceItem.invoice_bill_building_name},
                            {invoiceItem.invoice_bill_city},
                            {invoiceItem.invoice_bill_state},
                            {invoiceItem.invoice_bill_country} - {invoiceItem.invoice_bill_postal_code}
                        </p>
                    </div>
                </div>
                {/* Table */}
                <div className="table-responsive mt-4">
                    <table className="table table-bordered">
                        <thead className="table-light">
                            <tr>
                                <th>Item</th>
                                <th>Qty</th>
                                <th>Price</th>
                                <th>Discount</th>
                                <th className="text-end">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{invoiceItem.invoice_plan_name || '-'}</td>
                                <td>1</td>
                                <td>₹ {baseAmount.toFixed(2)}</td>
                                <td>-</td>
                                <td className="text-end">₹ {baseAmount.toFixed(2)}</td>
                            </tr>

                            <tr>
                                <td colSpan={2} rowSpan={4} className="border-0"></td>
                                <td colSpan={2}>Subtotal</td>
                                <td className="text-end">₹ {baseAmount.toFixed(2)}</td>
                            </tr>

                            <tr>
                                <td colSpan={2}>Item Discount</td>
                                <td className="text-end">₹ 0.00</td>
                            </tr>

                            <tr>
                                <td colSpan={2}>GST (18%)</td>
                                <td className="text-end">₹ {gstAmount.toFixed(2)}</td>
                            </tr>

                            <tr>
                                <td colSpan={2} className="border">Total</td>
                                <td className="text-end border">
                                    ₹ {totalAmount.toFixed(2)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* Total */}
                <div className="text-end mt-3">
                    <h5>Total: ₹ {totalAmount.toFixed(2)}</h5>
                </div>
                <hr />
                {/* Notes */}
                <div className="row">
                    <div className="col-md-6">
                        <h6>Note</h6>
                        <p>Thank you for your purchase. We appreciate your business!</p>
                    </div>
                    <div className="col-md-6 text-end">
                        <h6>Authorized Signature</h6>
                        <p>Codexo Software Pvt. Ltd.</p>
                    </div>
                </div>
                <hr />
                {/* Terms */}
                <div>
                    <h6>Terms & Conditions</h6>
                    <ol>
                        <li>Payment is due within 15 days.</li>
                        <li>Please mention invoice number while paying.</li>
                    </ol>
                </div>
            </div>
        </div>
    );
};

export default InvoiceTemplate;